"use client";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import { useRouter } from "next/navigation";

import { urlMaker } from "@/src/services/url-maker";

import IconInfo from "assets/svg/info.svg";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";
import { formGTMEventWithoutParametersGA4 } from "@/src/helpers/google-tag-manager/common";

import Button from "components/common/button";
import ModalTextContent from "components/modal-text-content";
import SaveSearchForm from "components/listing-search/save-search-form";
import LoginForm from "components/login/forms/login";
import ForgotPasswordForm from "components/login/forgot-password-form";

import styles from "./styles.module.css";

const Modal = dynamic(() => import("components/common/modal"), { ssr: false });

const NothingListingCard = ({ name, urlPath, criteria, pageType }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isForgotPasswordForm, setIsForgotPasswordForm] = useState(false);
  const [forgotFormMail, setForgotFormMail] = useState("");
  const [isLogin, setIsLogin] = useState(false);
  const [isLoadingCleanFilter, setIsLoadingCleanFilter] = useState(false);

  const router = useRouter();

  const handleModalClose = () => {
    setIsForgotPasswordForm(false);
    setIsModalOpen(false);
  };

  const handleForgotButton = () => {
    setIsForgotPasswordForm(!isForgotPasswordForm);
  };

  const handleModalOpen = () => {
    setIsModalOpen(true);
    Ga4WithEventParameters({
      eventName: "click_button",
      eventParameters: { label: "aramayi-kaydet" },
    });
  };

  useEffect(() => {
    const mail = localStorage.getItem("forgot-password-user");
    setForgotFormMail(mail);
    const isLogin = localStorage.getItem("user-data");
    setIsLogin(isLogin);
    setTimeout(() => {
      formGTMEventWithoutParametersGA4({
        eventName: "no_result",
      });
    }, 1000);
  }, []);

  const renderModal = () => {
    if (!isLogin) {
      return (
        <ModalTextContent>
          {!isForgotPasswordForm ? (
            <LoginForm modal handleForgotButton={handleForgotButton} successCallback={() => setIsLogin(true)} />
          ) : (
            <ForgotPasswordForm modal defaultMail={forgotFormMail} handleBackButtonForgotForm={handleForgotButton} />
          )}
        </ModalTextContent>
      );
    } else {
      return (
        <ModalTextContent>
          <SaveSearchForm name={name} urlPath={urlPath} />
        </ModalTextContent>
      );
    }
  };

  const handleClearFilter = async () => {
    try {
      setIsLoadingCleanFilter(true);
      const filteredParams = criteria.params.filter((param) => param.ownerType === "PROJECTS") || [];
      const newCriteria = {
        ...criteria,
        location: null,
        params: filteredParams,
      };
      const response = await urlMaker(newCriteria, "default");
      router.push(response.path);
    } catch (error) {
      setIsLoadingCleanFilter(false);
      console.error("An error occurred while applying the filter:", error);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.icon}>
        <IconInfo width="19" height="19" />
      </div>
      <div className={styles.infoWrapper}>
        <span className={styles.title}>Aradığınız kriterlere uygun ilan bulunamadı.</span>
        <p className={styles.info}>
          Arama kriterlerinizi değiştirerek tekrar deneyebilirsiniz ya da aramanıza uygun ilan yayınlandığında size
          haber verebilmemiz için aramanızı kaydedebilirsiniz.
        </p>
        <div className={styles.buttonWrapper}>
          {pageType === "listing" && (
            <div className={styles.button}>
              <Button size="M" outline onClick={handleModalOpen}>
                Aramayı Kaydet
              </Button>
            </div>
          )}
          <div className={styles.button}>
            <Button isLoading={isLoadingCleanFilter} onClick={handleClearFilter} size="M">
              Filtreyi Temizle
            </Button>
          </div>
        </div>
      </div>
      <Modal isOpen={isModalOpen} handleClose={() => handleModalClose()}>
        {renderModal()}
      </Modal>
    </div>
  );
};

NothingListingCard.propTypes = {
  name: PropTypes.string,
  urlPath: PropTypes.string,
  criteria: PropTypes.object,
  pageType: PropTypes.string,
};

export default NothingListingCard;
